import { useUseTerm } from "./hook";
import { useTermMutations } from "./mutation";
import { useTermQueries } from "./queries";

export const useTermService = {
  query: useTermQueries,
  mutation: useTermMutations,
  useUseTerm
};
